/* eslint-disable i18next/no-literal-string */
import type { ReactNode } from "react";
import { cn } from "~/lib/utils";
import weatherAlertIcon from "~/assets/landing/weather-alert-icon.svg";

/**
 * Ported from bouncieweb's `LandingPageComponents/WeatherAlertExample.js`.
 *
 * The frosted "Severe Thunderstorm Warning" push notification that floats over
 * the raindrop effect in the Weather Alerts bento item. Absolutely positioned;
 * on mobile it's centered near the bottom, and at md+ it shifts to the right so
 * it clears the item's heading text.
 */
export default function WeatherAlertExample({
  className,
  vehicleName = <>Luca&rsquo;s truck</>,
}: {
  className?: string;
  vehicleName?: ReactNode;
}) {
  return (
    // WeatherAlertsNotificationWrapper
    <div
      className={cn(
        "absolute bottom-8 left-1/2 flex w-[18rem] -translate-x-1/2 gap-2 rounded-[15px] p-3",
        "bg-white/40 [backdrop-filter:blur(2px)] [box-shadow:0_0_21px_rgba(0,0,0,.15)]",
        "md:bottom-16 md:left-[26rem]",
        "lg:bottom-12 lg:left-[25rem]",
        "xl:bottom-[4.3rem] xl:left-[27.5rem]",
        className,
      )}
    >
      {/* WeatherAlertsWrapper + icon */}
      <div className="flex flex-row items-center justify-center">
        <img
          src={weatherAlertIcon}
          alt="Thunderstorm icon"
          className="h-fit w-[100px]"
        />
      </div>
      <div>
        {/* WeatherAlertsNotificationHeading */}
        <div className="mb-1 text-[13px] font-bold text-[#2A71F3] sm:text-[14px]">
          Severe Thunderstorm Warning
        </div>
        {/* WeatherAlertsNotificationText */}
        <div className="text-[11px]">
          {vehicleName} is currently in an area where the NWS has issued a
          Severe Thunderstorm Warning.
        </div>
      </div>
    </div>
  );
}
